import React from "react";
import "./WhatComesNext.css";

import icon1 from "../../images/icon1.png";
import icon2 from "../../images/2icon.png";
import icon3 from "../../images/3icon.png";
import icon4 from "../../images/Group 16.png";
import icon5 from "../../images/Group 17.png";
import icon6 from "../../images/Group 18.png";
import icon7 from "../../images/Group 19 (1).png";
import icon8 from "../../images/Group 15 (1).png";

function WhatComesNext() {

  const topCards = [
    { icon: icon1, title: "Skills-Based Learning" },
    { icon: icon3, title: "Skills-Based Hiring" },
    { icon: icon8, title: "AI Talent Intelligence" },
    { icon: icon4, title: "Reskilling & Redeployment" },
  ];

  const bottomCards = [
    { icon: icon6, title: "Weighted skills instead of keyword resumes" },
    { icon: icon2, title: "Performance-based assessments instead of theoretical exams" },
    { icon: icon5, title: "Skills wallets instead of static transcripts" },
    { icon: icon7, title: "AI-driven matching instead of reactive hiring" },
  ];

  return (
    <section className="container-fluid what-next py-5">
      <div className="container my-5">

        {/* TITLE */}
        <div className="text-center mb-5">
          <h2 className="section-title">What Comes Next</h2>
          <p>
            We are building and backing companies that power:
          </p>
        </div>

        {/* TOP CARDS */}
        <div className="row g-4 mb-5">
          {topCards.map((card, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div className="whatComesCard power-card text-center p-5 h-100">

                <div className="icon-box">
                  <img src={card.icon} alt="" />
                </div>

                <div className=" mt-3">
                  {card.title}
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* FUTURE TITLE */}
        <div className="text-center mb-4">
          <h3 className="future-title">
            We believe the future is:
          </h3>
        </div>

        {/* BOTTOM CARDS */}
        <div className="row g-4">
          {bottomCards.map((card, index) => (
            <div className="col-12 col-sm-6 col-lg-3" key={index}>
              <div className="whatComesCard future-card text-center p-5 h-100">

                <div className="icon-box">
                  <img src={card.icon} alt="" />
                </div>

                <div className=" mt-3">
                  {card.title}
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default WhatComesNext;